export const getDomain = () => {
  if (typeof window !== `undefined`) {
    return `${window.location.protocol}//${window.location.host}`;
  }

  return ``;
};
